export interface Profile {
  id: string;
  business_name: string;
  email?: string;
  phone?: string;
  address?: string;
  website?: string;
  currency: string;
  tax_rate: number;
  theme: 'dark' | 'light';
  plan: 'free' | 'pro' | 'business';
  trust_score: number;
  referral_code: string;
  onboarded: boolean;
  avatar_url?: string;
  logo_url?: string;
  subscription_id?: string;
  subscription_status?: string;
  subscription_ends_at?: string;
  billing_period?: string;
  created_at: string;
  updated_at: string;
}

export interface Client {
  id: string;
  user_id: string;
  name: string;
  email?: string;
  phone?: string;
  company?: string;
  address?: string;
  notes?: string;
  total_revenue: number;
  invoice_count: number;
  created_at: string;
  updated_at: string;
}

export interface InvoiceItem {
  id: string;
  description: string;
  quantity: number;
  rate: number;
}

export type InvoiceStatus = 'draft' | 'sent' | 'viewed' | 'paid' | 'overdue' | 'cancelled';

export interface Invoice {
  id: string;
  user_id: string;
  client_id?: string;
  client?: Client;
  invoice_number: string;
  status: InvoiceStatus;
  items: InvoiceItem[];
  subtotal: number;
  discount: number;
  total: number;
  currency: string;
  notes?: string;
  issue_date: string;
  due_date?: string;
  share_token?: string;
  created_at: string;
  updated_at: string;
}

export type TaxEntryType = 'deposit' | 'withdrawal';

export interface TaxVaultEntry {
  id: string;
  user_id: string;
  type: TaxEntryType;
  amount: number;
  balance: number;
  source?: string;
  invoice_id?: string;
  created_at: string;
}

export type ContractStatus = 'draft' | 'sent' | 'signed' | 'expired';

export interface Contract {
  id: string;
  user_id: string;
  title: string;
  type?: string;
  status: ContractStatus;
  value?: number;
  start_date?: string;
  end_date?: string;
  created_at: string;
  updated_at: string;
}

export type NotificationType = 'invoice_paid' | 'reminder' | 'system';

export interface Notification {
  id: string;
  user_id: string;
  type: NotificationType;
  title: string;
  message?: string;
  read: boolean;
  created_at: string;
}

export interface AIMessage {
  id: string;
  user_id: string;
  role: 'user' | 'assistant';
  content: string;
  created_at: string;
}

export interface DashboardStats {
  totalRevenue: number;
  pendingAmount: number;
  taxVaultBalance: number;
  overdueInvoices: number;
  revenueChange: number;
}

export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar', flag: '🇺🇸' },
  { code: 'EUR', symbol: '€', name: 'Euro', flag: '🇪🇺' },
  { code: 'GBP', symbol: '£', name: 'British Pound', flag: '🇬🇧' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', flag: '🇮🇳' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', flag: '🇦🇪' },
  { code: 'CAD', symbol: '$', name: 'Canadian Dollar', flag: '🇨🇦' },
  { code: 'AUD', symbol: '$', name: 'Australian Dollar', flag: '🇦🇺' },
] as const;
